import { HttpResponse } from '@angular/common/http';

export function formatIsoDate(isoDate: string) {
  return new Date(isoDate).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

export function formatIsoDateTime(isoDate: string) {
  return new Date(isoDate).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

export function createQueryParams(params: any): string {
  const urlParams = new URLSearchParams(params);
  return urlParams.toString();
}

export function getFileNameFromHeader(headers: any): string | null {
  const contentDisposition = headers.get('Content-Disposition');
  if (!contentDisposition) return null;

  const matches = /filename="([^"]+)"/.exec(contentDisposition);
  return matches && matches[1] ? matches[1] : null;
}

export function getFormatedDateTime(): string {
  const agora = new Date();
  const data = agora.toISOString().split('T')[0];
  const hora = agora.getHours().toString().padStart(2, '0') + agora.getMinutes().toString().padStart(2, '0');
  return `${data}_${hora}`;
}

export function downloadResponseBlob(response: HttpResponse<Blob>, fileName: string) {
  const blob = new Blob([response.body!], { type: response.headers.get('Content-Type') || 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const nomeBase = fileName;
  const timestamp = getFormatedDateTime();
  a.download = `${nomeBase}_${timestamp}.xlsx`;
  a.click();
  window.URL.revokeObjectURL(url);
}
